<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <div class="animated fadeIn" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('settings.title')}}</strong>
                <div class="float-right">
                  <template v-if="advancedfeatures">
                    <router-link :to="{ path: '/keys'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('Keys.title')}}</router-link>
                  </template>

                </div>
              </div>

              <div class="card-body card-block" v-if="hasSavedAlert">
                <div class="alert alert-warning" role="alert">
                  {{$t('setting.nosaveddataalert')}}
                </div>

              </div>


              <div class="card-footer">
                <span :class="(hasnav)? 'd-none':''">&nbsp;
                  <button type="submit" class="btn btn-primary btn-sm" v-on:click="saveAllSettings">
                    <i class="fa fa-dot-circle-o"></i> {{$t('global.save')}}
                  </button>
                </span>

                <span :class="(!hasnav)? 'd-none':''">&nbsp;
                  <button v-on:click="savenavtest" type="button" class="btn btn-success btn-sm">
                    <i class="fa fa-dot-circle-o"></i> {{$t('setting.saveAndNavtest')}}
                  </button>
                </span>
              </div>

              <!--Magyar Adóhatósági Technikai felhasználó adatai-->
              <div class="card-body card-block fColumn ">
                <div class="row ">
                  <div class="col-12  ">
                    <h3>{{$t('setting.navTechUser')}}</h3>
                    <br>
                  </div>
                  <div v-if="HelperRole.hasRights(state, [15], false)" class="col-12  ">
                    <div class="alert alert-warning">{{ $t('setting.attentionNavTechUser') }}</div>

                    <div class="row form-group">
                      <div class="col col-md-3"><label for="hasnav" class=" form-control-label">{{ $t('setting.hasnav') }}</label></div>
                      <div class="col-12 col-md-9">
                        <select class="form-control" id="hasnav" v-model="hasnav" name="hasnav" v-validate="''">
                          <!--<option value="">{{$t('form.pleasechoose')}} </option>-->
                          <option :value="false">{{$t('global.no')}}</option>
                          <option :value="true">{{$t('global.yes')}} </option>
                        </select>
                        <small class="form-text text-muted"></small>
                      </div>
                    </div>
                    <div :class="(!hasnav)? 'd-none':''">


                      <div class="row form-group">
                        <div class="col col-md-3"><label for="nav_api_version" class=" form-control-label">{{ $t('setting.nav_api_version') }}</label></div>
                        <div class="col-12 col-md-9">
                          <select class="form-control" id="nav_api_version" v-model="nav_api_version" name="nav_api_version" v-validate="''">
                            <!--<option value="2.0">2.0</option>-->
                            <option value="3.0">3.0</option>
                          </select>
                          <small class="form-text text-muted"></small>
                        </div>
                      </div>

                      <div class="row form-group">
                        <div class="col col-6 extensionLine">
                          <label for="navTechUserName" class=" form-control-label">{{$t('setting.navTechUserName')}}</label>
                        </div>
                        <div class="col col-6">
                          <InputText id="navTechUserName" name="navTechUserName" v-model="navTechUserName" :v-validate="(hasnav)?'required':''" hasToKeyboard="auto" value="" :title="$t('setting.navTechUserName')"
                                     placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('navTechUserName')"/>
                          <small class="unit form-text text-muted d-none"></small>
                        </div>
                      </div>
                      <div class="row form-group">
                        <div class="col col-6 extensionLine">
                          <label for="navTechUserPass" class=" form-control-label">{{$t('setting.navTechUserPass')}}</label>
                        </div>
                        <div class="col col-6">
                          <table class="w100">
                            <tr>
                              <td>
                                <InputText :type="passFieldType" id="navTechUserPass" name="navTechUserPass" v-model="navTechUserPass" v-validate="" hasToKeyboard="auto" value=""
                                           :title="$t('setting.navTechUserPass')"
                                           placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('navTechUserPass')"/>
                                <small class="unit form-text text-muted d-none"></small>
                              </td>
                              <td class="w1">
                                <div class="input-group topminus2px">
                                                                    <span class="btn btn-secondary" v-on:click="viewChange">
                                                                    <i class="fa fa-eye-slash"></i></span>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <div class="row form-group">
                        <div class="col col-6 extensionLine">
                          <label for="navTechXmlSignatureKey" class=" form-control-label">{{$t('setting.navTechXmlSignatureKey')}}</label>
                        </div>
                        <div class="col col-6">
                          <InputText id="navTechXmlSignatureKey" name="navTechXmlSignatureKey" v-model="navTechXmlSignatureKey" v-validate="" hasToKeyboard="auto" value=""
                                     :title="$t('setting.navTechXmlSignatureKey')"
                                     placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('navTechXmlSignatureKey')"/>
                          <small class="unit form-text text-muted d-none"></small>
                        </div>
                      </div>
                      <div class="row form-group">
                        <div class="col col-6 extensionLine">
                          <label for="navTechXmlChangeKey" class=" form-control-label">{{$t('setting.navTechXmlChangeKey')}}</label>
                        </div>
                        <div class="col col-6">
                          <InputText id="navTechXmlChangeKey" name="navTechXmlChangeKey" v-model="navTechXmlChangeKey" v-validate="" hasToKeyboard="auto" value=""
                                     :title="$t('setting.navTechXmlChangeKey')"
                                     placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('navTechXmlChangeKey')"/>
                          <small class="unit form-text text-muted d-none"></small>
                        </div>
                      </div>
                      <div class="row form-group">
                        <div class="col col-6 extensionLine">
                          <label for="navtaxnumber" class=" form-control-label">{{$t('setting.navtaxnumber')}}</label>
                        </div>
                        <div class="col col-6">
                          <InputText id="navtaxnumber" name="navtaxnumber" v-model="navtaxnumber" v-validate="" hasToKeyboard="auto" value=""
                                     :title="$t('setting.navtaxnumber')"
                                     placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('navtaxnumber')"/>
                          <small class="unit form-text text-muted d-none"></small>
                        </div>
                      </div>
                      <div class="row form-group">
                        <div class="col col-12 ">
                          <!--<button v-on:click="navtest" type="button" class="btn btn-success btn">-->
                          <!--<i class="fa fa-dot-circle-o"></i> {{$t('setting.navtest')}}-->
                          <!--</button>-->
                        </div>
                      </div>

                      <div>
                        <label class="switch switch-3d switch-danger mr-3">
                          <input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="openadvancedfeatures" class="switch-input checkboxBig">
                          <span class="switch-label"></span> <span class="switch-handle"></span></label>
                      </div>
                      <div v-if="openadvancedfeatures">
                        <h3 data-v-53cc84dd="">{{$t('setting.advancedfeatures')}}</h3>
                        <div class="alert alert-danger">
                          {{ $t('setting.attentiontext') }}
                        </div>

                        <div class="row form-group">
                          <div class="col col-md-3">
                            <label for="advancedfeatures" class=" form-control-label">{{$t('setting.advancedfeatures')}}</label>
                          </div>
                          <div class="col-12 col-md-9">

                            <select id="advancedfeatures" v-model="advancedfeatures" class="form-control" name="advancedfeatures">
                              <option :value="true">{{$t('global.yes')}}</option>
                              <option :value="false">{{$t('global.no')}}</option>
                            </select>
                            <small class="unit form-text text-muted d-none"></small>
                          </div>
                        </div>

                        <template v-if="advancedfeatures">
                          <div class="row form-group">
                            <div class="col col-md-3">
                              <label for="APIurlType" class=" form-control-label">{{$t('setting.apiurltype')}}</label>
                            </div>
                            <div class="col-12 col-md-9">
                              <select id="APIurlType" v-model="APIurlType" class="form-control" name="APIurlType">
                                <option value="live">{{$t('setting.apiurllive')}}</option>
                                <option value="test">{{$t('setting.apiurltest')}}</option>
                              </select>
                              <small class="unit form-text text-muted d-none"></small>
                            </div>
                          </div>
                          <!--<div class="row form-group">-->
                          <!--<div class="col col-md-3">-->
                          <!--<label for="APIurl" class=" form-control-label">{{$t('setting.apiurl')}}</label>-->
                          <!--</div>-->
                          <!--<div class="col-12 col-md-9">-->
                          <!--<InputText id="APIurl" name="APIurl" v-model="APIurl" v-validate="''" hasToKeyboard="auto" value=""-->
                          <!--:title="$t('invoice.APIurl')" readonly-->
                          <!--placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('APIurl')"/>-->
                          <!--<small class="unit form-text text-muted d-none"></small>-->
                          <!--</div>-->
                          <!--</div>-->
                        </template>

                      </div>

                    </div>

                  </div>
                  <div v-if="!HelperRole.hasRights(state, [15], false)" class="col-12  ">{{$t("global.navmoduleNotEnable")}}</div>
                </div>
              </div>


              <div class="card-body card-block">
                <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
                <h3>{{$t('settings.titlelangmoney')}}</h3>
                <br>


                <div class="row form-group">
                  <div class="col col-md-3"><label for="default_lang" class=" form-control-label">{{ $t('settings.lang.default_lang') }}</label></div>
                  <div class="col-12 col-md-9">
                    <select class="form-control" id="default_lang" v-model="default_lang" name="default_lang" v-validate="'required'" v-bind:class="{'is-invalid': errors.has('default_lang')}">
                      <option value="">{{$t('form.pleasechoose')}} </option>
                      <option value="en">{{$t('global.lang.en')}}</option>
                      <option value="ie">{{$t('global.lang.ie')}} </option>
                      <option value="hu">{{$t('global.lang.hu')}} </option>
                      <option value="us">{{$t('global.lang.us')}} </option>
                    </select>
                  </div>
                </div>
                <!--</div>-->

                <!--<div class="card-footer">-->
                <!--<button type="submit" class="btn btn-primary btn-sm" v-on:click="langsave()">-->
                <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.submit')}}-->
                <!--</button>-->
                <!--</div>-->

                <!--<div class="card-body card-block">-->

                <!--<h3>{{$t('settings.money.title')}}</h3>-->
                <!--<br>-->

                <div class="row form-group">
                  <div class="col col-md-3"><label for="default_type" class=" form-control-label">{{ $t('settings.money.default_type') }}</label></div>
                  <div class="col-12 col-md-9">
                    <select class="form-control" id="default_type" v-model="default_type" name="default_type" v-validate="'required'" v-bind:class="{'is-invalid': errors.has('default_type')}">
                      <option value="">{{$t('form.pleasechoose')}} </option>
                      <option value="eur">{{$t('global.moneys.eur')}}</option>
                      <option value="huf">{{$t('global.moneys.huf')}} </option>
                    </select>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col col-md-3"><label for="default_fix" class=" form-control-label">{{ $t('settings.money.default_fix') }}</label></div>
                  <div class="col-12 col-md-9">
                    <input v-model="default_fix" type="text" id="default_fix" placeholder="" class="form-control" name="default_fix"
                           v-validate="'required'" v-bind:class="{'is-invalid':errors.has('default_fix')}">
                    <small class="form-text text-muted"></small>
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col col-md-3"><label for="default_presuf" class=" form-control-label">{{ $t('settings.money.default_presuf') }}</label></div>
                  <div class="col-12 col-md-9">
                    <select class="form-control" id="default_presuf" v-model="default_presuf" name="default_presuf" v-validate="'required'" v-bind:class="{'is-invalid': errors.has('default_presuf')}">
                      <option value="">{{$t('form.pleasechoose')}} </option>
                      <option value="prefix">{{$t('global.default_presuf.prefix')}}</option>
                      <option value="suffix">{{$t('global.default_presuf.suffix')}} </option>
                    </select>
                    <small class="form-text text-muted"></small>
                  </div>
                </div>

              </div>

              <div class="card-body card-block">
                <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
                <h3>{{$t('settings.titleaccountant')}}</h3>
                <br>

                <div class="row form-group">
                  <div class="col col-md-3"><label for="cash_settlement" class=" form-control-label">{{ $t('settings.app.cash_settlement') }}</label></div>
                  <div class="col-12 col-md-9">
                    <select class="form-control" id="cash_settlement" v-model="cash_settlement" name="cash_settlement" v-validate="'required'" v-bind:class="{'is-invalid': errors.has('cash_settlement')}">
                      <!--<option value="">{{$t('form.pleasechoose')}} </option>-->
                      <option value="0">{{$t('global.no')}}</option>
                      <option value="1">{{$t('global.yes')}} </option>
                    </select>
                    <small class="form-text text-muted"></small>
                  </div>
                </div>

              </div>

              <!--Invoice edit view settings-->
              <template v-if="false">
                <div class="card-body card-block">

                  <!-- PDF BEÁLLíTÁSOK   --- INNEN  -->
                  <!--offers and stock-->

                  <h3>{{$t('settings.pdfdocuments.title')}}</h3>
                  <br>
                  <p>{{$t('settings.pdfdocuments.text')}}</p>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="price_number_of_decimals" class=" form-control-label">{{ $t('settings.pdfdocuments.price_number_of_decimals') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="price_number_of_decimals" type="text" id="price_number_of_decimals" placeholder="" class="form-control" name="price_number_of_decimals"
                             v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('price_number_of_decimals')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="discount_number_of_decimals" class=" form-control-label">{{ $t('settings.pdfdocuments.discount_number_of_decimals') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="discount_number_of_decimals" type="text" id="discount_number_of_decimals" placeholder="" class="form-control" name="discount_number_of_decimals"
                             v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('discount_number_of_decimals')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="sumprice_number_of_decimals" class=" form-control-label">{{ $t('settings.pdfdocuments.sumprice_number_of_decimals') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="sumprice_number_of_decimals" type="text" id="sumprice_number_of_decimals" placeholder="" class="form-control" name="sumprice_number_of_decimals"
                             v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('sumprice_number_of_decimals')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="defaultdtpaymentdeadline" class=" form-control-label">{{ $t('settings.pdfdocuments.defaultdtpaymentdeadline') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="defaultdtpaymentdeadline" type="text" id="defaultdtpaymentdeadline" placeholder="" class="form-control" name="defaultdtpaymentdeadline"
                             v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('defaultdtpaymentdeadline')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="base_item" class=" form-control-label">{{ $t('settings.money.base_item') }}</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<input v-model="base_item" type="text" id="base_item" placeholder="" class="form-control" name="base_item"-->
                  <!--v-validate="'required'" v-bind:class="{'is-invalid':errors.has('base_item')}">-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->

                  <div class="row form-group">
                    <div class="col col-6 extensionLine">
                      <label for="base_item" class=" form-control-label">{{$t('settings.pdfdocuments.base_item')}}</label>
                    </div>
                    <div class="col col-6">

                      <select id="base_item" v-model="base_item" class="form-control" name="base_item">
                        <option value="net">{{$t('invoice.net')}}</option>
                        <option value="gross">{{$t('invoice.gross')}}</option>
                      </select>
                      <small class="unit form-text text-muted d-none"></small>
                    </div>
                  </div>


                  <!--TODO - - Ilyen kéne mindenfél efooterhez szla, offer, szllító, stb-->
                  <!--<p>Kéne mindegyik fajtához</p>-->
                  <h4>{{ $t('settings.pdfdocuments.footertext') }}</h4>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="footertext" class=" form-control-label">{{ $t('settings.pdfdocuments.footertext') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="footertext" type="text" id="footertext" placeholder="" class="form-control" name="footertext"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('footertext')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                </div>
                <div class="card-footer">
                  <button type="submit" class="btn btn-primary btn-sm" v-on:click="moneysave()">
                    <i class="fa fa-dot-circle-o"></i> {{$t('global.submit')}}
                  </button>
                </div>
              </template>

              <!--document Serial Number-->
              <template v-if="false">
                <!--<div class="card-body card-block">-->
                <!--&lt;!&ndash; PDF BEÁLLíTÁSOK   -&#45;&#45; EDDIG&ndash;&gt;-->

                <!--<template v-if="Helper.checkRolesAuto(this, 6,1) || Helper.checkRolesAuto(this, 3,11)">-->

                <!--<h3>{{$t('settings.identifiersTitle')}}</h3>-->
                <!--<br>-->
                <!--<p>{{$t('settings.identifiersText')}}</p>-->
                <!--</template>-->


                <!--&lt;!&ndash;documentserialnumber&ndash;&gt;-->

                <!--<template v-if="Helper.checkRolesAuto(this, 3,11) ">-->
                <!--&lt;!&ndash;offers &ndash;&gt;-->
                <!--<div class="row form-group">-->
                <!--<div class="col-4 col-md-2"><label for="docsernum.offer_key" class=" form-control-label">{{ $t('settings.docsernum.offer_key') }}</label></div>-->
                <!--<div class="col-8 col-md-4">-->
                <!--<input v-model="docsernum.offer_key" type="text" id="docsernum.offer_key" placeholder="" class="form-control" name="docsernum.offer_key"-->
                <!--v-validate="'required'" v-bind:class="{'is-invalid':errors.has('docsernum.offer_key')}">-->
                <!--<small class="form-text text-muted"></small>-->
                <!--</div>-->
                <!--<div class="col-4 col-md-2"><label for="docsernum.offer_number" class=" form-control-label">{{ $t('settings.docsernum.offer_number') }}</label></div>-->
                <!--<div class="col-8 col-md-4">-->
                <!--<input v-model="docsernum.offer_number" type="text" id="docsernum.offer_number" placeholder="" class="form-control" name="docsernum.offer_number"-->
                <!--v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('docsernum.offer_number')}">-->
                <!--<small class="form-text text-muted"></small>-->
                <!--</div>-->
                <!--</div>-->
                <!--</template>-->
                <!--<template v-if=" Helper.checkRolesAuto(this, 6,1)">-->

                <!--&lt;!&ndash;offer_key&ndash;&gt;-->
                <!--&lt;!&ndash;offer_number&ndash;&gt;-->
                <!--&lt;!&ndash;order_key&ndash;&gt;-->
                <!--&lt;!&ndash;order_number&ndash;&gt;-->
                <!--&lt;!&ndash;revenue_key&ndash;&gt;-->
                <!--&lt;!&ndash;revenue_number&ndash;&gt;-->
                <!--&lt;!&ndash;buyerorder_key&ndash;&gt;-->
                <!--&lt;!&ndash;buyerorder_number&ndash;&gt;-->
                <!--&lt;!&ndash;deliverynote_key&ndash;&gt;-->
                <!--&lt;!&ndash;deliverynote_number&ndash;&gt;-->
                <!--&lt;!&ndash;invoice_key&ndash;&gt;-->
                <!--&lt;!&ndash;invoice_number&ndash;&gt;-->

                <!--&lt;!&ndash;stock&ndash;&gt;-->

                <!--&lt;!&ndash;<div class="row form-group">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-4 col-md-2"><label for="docsernum.buyerorder_key" class=" form-control-label">{{ $t('settings.docsernum.buyerorder_key') }}</label></div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-8 col-md-4">&ndash;&gt;-->
                <!--&lt;!&ndash;<input v-model="docsernum.buyerorder_key" type="text" id="docsernum.buyerorder_key" placeholder="" class="form-control" name="docsernum.buyerorder_key"&ndash;&gt;-->
                <!--&lt;!&ndash;v-validate="'required'" v-bind:class="{'is-invalid':errors.has('docsernum.buyerorder_key')}">&ndash;&gt;-->
                <!--&lt;!&ndash;<small class="form-text text-muted"></small>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-4 col-md-2"><label for="docsernum.buyerorder_number" class=" form-control-label">{{ $t('settings.docsernum.buyerorder_number') }}</label></div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-8 col-md-4">&ndash;&gt;-->
                <!--&lt;!&ndash;<input v-model="docsernum.buyerorder_number" type="text" id="docsernum.buyerorder_number" placeholder="" class="form-control" name="docsernum.buyerorder_number"&ndash;&gt;-->
                <!--&lt;!&ndash;v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('docsernum.buyerorder_number')}">&ndash;&gt;-->
                <!--&lt;!&ndash;<small class="form-text text-muted"></small>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="row form-group">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-4 col-md-2"><label for="docsernum.order_key" class=" form-control-label">{{ $t('settings.docsernum.order_key') }}</label></div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-8 col-md-4">&ndash;&gt;-->
                <!--&lt;!&ndash;<input v-model="docsernum.order_key" type="text" id="docsernum.order_key" placeholder="" class="form-control" name="docsernum.order_key"&ndash;&gt;-->
                <!--&lt;!&ndash;v-validate="'required'" v-bind:class="{'is-invalid':errors.has('docsernum.order_key')}">&ndash;&gt;-->
                <!--&lt;!&ndash;<small class="form-text text-muted"></small>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-4 col-md-2"><label for="docsernum.order_number" class=" form-control-label">{{ $t('settings.docsernum.order_number') }}</label></div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-8 col-md-4">&ndash;&gt;-->
                <!--&lt;!&ndash;<input v-model="docsernum.order_number" type="text" id="docsernum.order_number" placeholder="" class="form-control" name="docsernum.order_number"&ndash;&gt;-->
                <!--&lt;!&ndash;v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('docsernum.order_number')}">&ndash;&gt;-->
                <!--&lt;!&ndash;<small class="form-text text-muted"></small>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->

                <!--<div class="row form-group">-->
                <!--<div class="col-4 col-md-2"><label for="docsernum.revenue_key" class=" form-control-label">{{ $t('settings.docsernum.revenue_key') }}</label></div>-->
                <!--<div class="col-8 col-md-4">-->
                <!--<input v-model="docsernum.revenue_key" type="text" id="docsernum.revenue_key" placeholder="" class="form-control" name="docsernum.revenue_key"-->
                <!--v-validate="'required'" v-bind:class="{'is-invalid':errors.has('docsernum.revenue_key')}">-->
                <!--<small class="form-text text-muted"></small>-->
                <!--</div>-->
                <!--<div class="col-4 col-md-2"><label for="docsernum.revenue_number" class=" form-control-label">{{ $t('settings.docsernum.revenue_number') }}</label></div>-->
                <!--<div class="col-8 col-md-4">-->
                <!--<input v-model="docsernum.revenue_number" type="text" id="docsernum.revenue_number" placeholder="" class="form-control" name="docsernum.revenue_number"-->
                <!--v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('docsernum.revenue_number')}">-->
                <!--<small class="form-text text-muted"></small>-->
                <!--</div>-->
                <!--</div>-->

                <!--<div class="row form-group">-->
                <!--<div class="col-4 col-md-2"><label for="docsernum.deliverynote_key" class=" form-control-label">{{ $t('settings.docsernum.deliverynote_key') }}</label></div>-->
                <!--<div class="col-8 col-md-4">-->
                <!--<input v-model="docsernum.deliverynote_key" type="text" id="docsernum.deliverynote_key" placeholder="" class="form-control" name="docsernum.deliverynote_key"-->
                <!--v-validate="'required'" v-bind:class="{'is-invalid':errors.has('docsernum.deliverynote_key')}">-->
                <!--<small class="form-text text-muted"></small>-->
                <!--</div>-->
                <!--<div class="col-4 col-md-2"><label for="docsernum.deliverynote_number" class=" form-control-label">{{ $t('settings.docsernum.deliverynote_number') }}</label></div>-->
                <!--<div class="col-8 col-md-4">-->
                <!--<input v-model="docsernum.deliverynote_number" type="text" id="docsernum.deliverynote_number" placeholder="" class="form-control" name="docsernum.deliverynote_number"-->
                <!--v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('docsernum.deliverynote_number')}">-->
                <!--<small class="form-text text-muted"></small>-->
                <!--</div>-->
                <!--</div>-->


                <!--&lt;!&ndash;CLOUD INVOICE&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="row form-group">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-4 col-md-2"><label for="docsernum.invoice_key" class=" form-control-label">{{ $t('settings.docsernum.invoice_key') }}</label></div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-8 col-md-4">&ndash;&gt;-->
                <!--&lt;!&ndash;<input v-model="docsernum.invoice_key" type="text" id="docsernum.invoice_key" placeholder="" class="form-control" name="docsernum.invoice_key"&ndash;&gt;-->
                <!--&lt;!&ndash;v-validate="'required'" v-bind:class="{'is-invalid':errors.has('docsernum.invoice_key')}">&ndash;&gt;-->
                <!--&lt;!&ndash;<small class="form-text text-muted"></small>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-4 col-md-2"><label for="docsernum.invoice_number" class=" form-control-label">{{ $t('settings.docsernum.invoice_number') }}</label></div>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="col-8 col-md-4">&ndash;&gt;-->
                <!--&lt;!&ndash;<input v-model="docsernum.invoice_number" type="text" id="docsernum.invoice_number" placeholder="" class="form-control" name="docsernum.invoice_number"&ndash;&gt;-->
                <!--&lt;!&ndash;v-validate="'required'" v-bind:class="{'is-invalid':errors.has('docsernum.invoice_number')}">&ndash;&gt;-->
                <!--&lt;!&ndash;<small class="form-text text-muted"></small>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->


                <!--</template>-->
                <!--&lt;!&ndash;<template v-if="Helper.checkRolesAuto(this, 6,1) || Helper.checkRolesAuto(this, 3,11)">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="card-footer">&ndash;&gt;-->
                <!--&lt;!&ndash;<button type="submit" class="btn btn-primary btn-sm" v-on:click="docsernumsave()">&ndash;&gt;-->
                <!--&lt;!&ndash;<i class="fa fa-dot-circle-o"></i> {{$t('global.submit')}}&ndash;&gt;-->
                <!--&lt;!&ndash;</button>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;</template>&ndash;&gt;-->


                <!--&lt;!&ndash;documentserialnumber&ndash;&gt;-->

                <!--</div>-->
                <!--<div class="card-footer">-->
                <!--<button type="submit" class="btn btn-primary btn-sm" v-on:click="docsernumsave()">-->
                <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.submit')}}-->
                <!--</button>-->
                <!--</div>-->

              </template>


              <div class="card-body card-block fColumn pt-0 pb-15">

                <!--<div class="row form-group">-->
                <!--<div class="col col-6 extensionLine">-->
                <!--<label for="advancedfeatures" class=" form-control-label">{{$t('setting.advancedfeatures')}}</label>-->
                <!--</div>-->
                <!--<div class="col col-6">-->

                <!--<select id="advancedfeatures" v-model="advancedfeatures" class="form-control" name="advancedfeatures">-->
                <!--<option :value="true">{{$t('global.yes')}}</option>-->
                <!--<option :value="false">{{$t('global.no')}}</option>-->
                <!--</select>-->
                <!--<small class="unit form-text text-muted d-none"></small>-->
                <!--</div>-->
                <!--</div>-->


                <!--<div class="row form-group">-->
                <!--<div class="col col-6 extensionLine"><label for="outerprogsupplier" class=" form-control-label">{{ $t('setting.outerprogsupplier') }}</label></div>-->
                <!--<div class="col col-6">-->
                <!--<select class="form-control" id="outerprogsupplier" v-model="outerprogsupplier" name="outerprogsupplier" v-validate="''" v-bind:class="{'is-invalid': errors.has('default_presuf')}">-->
                <!--&lt;!&ndash;<option value="">{{$t('form.pleasechoose')}} </option>&ndash;&gt;-->
                <!--<option value="false">{{$t('global.no')}}</option>-->
                <!--<option value="true">{{$t('global.yes')}} </option>-->
                <!--</select>-->
                <!--<small class="form-text text-muted"></small>-->
                <!--</div>-->
                <!--</div>-->


              </div>
              <!--<hr>-->


              <div class="card-footer">
                <span :class="(hasnav)? 'd-none':''">&nbsp;
                  <button type="submit" class="btn btn-primary btn-sm" v-on:click="saveAllSettings">
                    <i class="fa fa-dot-circle-o"></i> {{$t('global.save')}}
                  </button>
                </span>

                <span :class="(!hasnav)? 'd-none':''">&nbsp;
                  <button v-on:click="savenavtest" type="button" class="btn btn-success btn-sm">
                    <i class="fa fa-dot-circle-o"></i> {{$t('setting.saveAndNavtest')}}
                  </button>
                </span>

              </div>


            </div>
          </div>


          <div class="animated fadeIn">
            <div class="col-lg-12">

              <!--<div><span v-on:click="reloadpage" class="btn btn-secondary">{{$t('global.reloadpage')}}</span></div>-->
              <div class="card-footer">
                <span v-on:click="reloadpage" class="btn btn-secondary">{{$t('global.reloadpage')}}</span>
                <!--<button type="submit" class="btn btn-primary btn-sm" v-on:click="langsave()">-->
                <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.submit')}}-->
                <!--</button>-->
              </div>


            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!state.id_company">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import SettingsContainer from '@/helper/SettingsContainer';
  import HelperRole from "@/helper/HelperRole";
  import InputText from '@/components/InputText.vue';

  export default {
    name: 'Settings',
    data() {
      return {
//        moduleRights: []
//        , moduleRightsIds: []
//        , roles: []
//        , user_role: 0
//        ,
        Helper: Helper

        , price_number_of_decimals: 2
        , discount_number_of_decimals: 2
        , sumprice_number_of_decimals: 2
        , defaultdtpaymentdeadline: 2
//        , sumprice_eur_number_of_decimals: 2
//        , sumprice_usd_number_of_decimals: 2
        , footertext: ""
        , base_item: "gross"
        ,

        hasSavedAlert: true,
        default_type: "eur",
        default_fix: "€",
        default_presuf: "prefix",
        cash_settlement: "0",

        default_lang: "en",
        data: [],
        AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }

        , documentserialnumber: []
        , docsernum: {
          offer_key: "",
          offer_number: "",
          order_key: "",
          order_number: "",
          revenue_key: "",
          revenue_number: "",
          buyerorder_key: "",
          buyerorder_number: "",
          deliverynote_key: "",
          deliverynote_number: "",
          invoice_key: "",
          invoice_number: "",

        },

        passFieldType: "password",
        hasnav: false,
        nav_api_version: "3.0",
        navTechUserName: "",
        navTechUserPass: "",
        navTechXmlSignatureKey: "",
        navTechXmlChangeKey: "",
        navtaxnumber: "",

        advancedfeatures: false,
        APIurlType: "live",
        APIurl: "",


        HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , openadvancedfeatures: 0

      };
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          modul.getAllSettings();

        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },
      'advancedfeatures': function (newVal, oldVal) {
        const modul = this;
        if (!newVal) {
          modul.APIurlType = "live";
          modul.openadvancedfeatures = 1
        }
      },
      documentserialnumber: function (newVal, oldVal) {
        const modul = this;
        if (Array.isArray(newVal)) {
//          offer_key
//          offer_number
//          order_key
//          order_number
//          revenue_key
//          revenue_number
//          buyerorder_key
//          buyerorder_number
//          deliverynote_key
//          deliverynote_number
//          invoice_key
//          invoice_number
          Array.prototype.forEach.call(newVal, function (e, i) {
            if (e.type === "offer_cloud") {
              modul.docsernum.offer_key = e.idkey;
              modul.docsernum.offer_number = e.idnextnumber;
            }
            if (e.type === "order_cloud") {
              modul.docsernum.order_key = e.idkey;
              modul.docsernum.order_number = e.idnextnumber;
            }
            if (e.type === "revenue_cloud") {
              modul.docsernum.revenue_key = e.idkey;
              modul.docsernum.revenue_number = e.idnextnumber;
            }
            if (e.type === "buyerorder_cloud") {
              modul.docsernum.buyerorder_key = e.idkey;
              modul.docsernum.buyerorder_number = e.idnextnumber;
            }
            if (e.type === "deliverynote_cloud") {
              modul.docsernum.deliverynote_key = e.idkey;
              modul.docsernum.deliverynote_number = e.idnextnumber;
            }
            if (e.type === "invoice_cloud") {
              modul.docsernum.invoice_key = e.idkey;
              modul.docsernum.invoice_number = e.idnextnumber;
            }
          })
        }
      },
      data: function (newData, oldData) {
        const modul = this;
        modul.setMoneys(newData);
        modul.setNavs(newData);
      },
      default_type: function (newData, oldData) {
        const modul = this;
        console.log(newData)
        if (newData === "eur") {
          modul.default_fix = "€";
          modul.default_presuf = "prefix";
        }
        if (newData === "huf") {
          modul.default_fix = "Ft";
          modul.default_presuf = "suffix";
        }
      },
    },
    mounted() {
      const modul = this;
      modul.handleRights();
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], false)) {
          modul.hasRole = true;
        }
        if (modul.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        modul.getAllSettings();
//        modul.getSettings();
//        modul.getDocumentSerialNumber();
      },
      viewChange: function () {
        const modul = this;
        if (modul.passFieldType === "text") {
          modul.passFieldType = "password";
        } else {
          modul.passFieldType = "text";
        }
      },

      reloadpage(){
        const modul = this;
        location.reload(true);
      },

      getAllSettings(){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getAllSettings({id_company: modul.state.id_company}).then(function (res) {
          if (res && res.result && res.data) {

            modul.base_item = Helper.String(res.data.base_item);
            modul.default_fix = Helper.String(res.data.default_fix);
            modul.default_lang = Helper.String(res.data.default_lang);
            modul.default_presuf = Helper.String(res.data.default_presuf);
            modul.cash_settlement = (res.data.cash_settlement) ? Helper.String(res.data.cash_settlement) : "0";
            modul.default_type = Helper.String(res.data.default_type);
            modul.defaultdtpaymentdeadline = Helper.String(res.data.defaultdtpaymentdeadline);
            modul.discount_number_of_decimals = Helper.String(res.data.discount_number_of_decimals);
            modul.footertext = Helper.String(res.data.footertext);
            modul.hasnav = (res.data.hasnav === "true");
            modul.navTechUserName = Helper.String(res.data.navTechUserName);
            modul.navTechUserPass = Helper.String(res.data.navTechUserPass);
            modul.navTechXmlChangeKey = Helper.String(res.data.navTechXmlChangeKey);
            modul.navTechXmlSignatureKey = Helper.String(res.data.navTechXmlSignatureKey);
            modul.nav_api_version = Helper.String(res.data.nav_api_version);
            modul.navtaxnumber = Helper.String(res.data.navtaxnumber);
            modul.price_number_of_decimals = Helper.String(res.data.price_number_of_decimals);
            modul.sumprice_number_of_decimals = Helper.String(res.data.sumprice_number_of_decimals);
//            modul.sumprice_eur_number_of_decimals = Helper.String(res.data.sumprice_eur_number_of_decimals);
//            modul.sumprice_usd_number_of_decimals = Helper.String(res.data.sumprice_usd_number_of_decimals);
            modul.advancedfeatures = (res.data.advancedfeatures === "true");
            modul.openadvancedfeatures = (res.data.advancedfeatures === "true")?1:0;
            modul.APIurlType = Helper.String(res.data.APIurlType);

            modul.data = res.data;

            if (modul.data && typeof modul.data === "object" && Object.keys(modul.data).length > 0) {
              modul.hasSavedAlert = false;
            }
            modul.AlertInPage.msg = "";

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      savenavtest(){
        const modul = this;
        modul.saveAllSettings(modul.navtest);
      },
      saveAllSettings(cb){
        const modul = this;
        const data = {};
        data.default_lang = modul.default_lang;

        data.base_item = modul.base_item;
        data.default_fix = modul.default_fix;
        data.default_presuf = modul.default_presuf;
        data.cash_settlement = modul.cash_settlement;
        data.default_type = modul.default_type;
        data.defaultdtpaymentdeadline = modul.defaultdtpaymentdeadline;
        data.discount_number_of_decimals = modul.discount_number_of_decimals;
        data.price_number_of_decimals = modul.price_number_of_decimals;
        data.sumprice_number_of_decimals = modul.sumprice_number_of_decimals;
//        data.sumprice_eur_number_of_decimals = modul.sumprice_eur_number_of_decimals;
//        data.sumprice_usd_number_of_decimals = modul.sumprice_usd_number_of_decimals;
        data.footertext = modul.footertext;

        data.hasnav = modul.hasnav;
        data.nav_api_version = modul.nav_api_version;
        data.navTechUserName = modul.navTechUserName;
        data.navTechUserPass = modul.navTechUserPass;
        data.navTechXmlSignatureKey = modul.navTechXmlSignatureKey;
        data.navTechXmlChangeKey = modul.navTechXmlChangeKey;
        data.navtaxnumber = modul.navtaxnumber;
        data.advancedfeatures = modul.advancedfeatures;
        data.APIurlType = modul.APIurlType;

//        data.data=Helper.makeFilteredObjectByKeys(modul.data, ["hasnav","nav_api_version","navTechUserName","navTechUserPass","navTechXmlSignatureKey","navTechXmlChangeKey","navtaxnumber"]);
        const postObj = {};
        postObj.id_company = modul.$store.state.id_company;
        postObj.data = data;
        const alertId = Math.random();
        modul.$eventBus.$emit('globalAlert', {
          id: alertId,
          type: "warning",
          msgPreInner: "",
          msg: "form.in_progress",
          msgPostInner: "",
          delay: 50000
        });
//        modul.AlertInPage.msg = "form.in_progress";
//        modul.AlertInPage.type = "warning";

        Api.saveAllSettings(postObj).then(function (res) {
          if (res && res.result) {
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "success",
              msgPreInner: "",
              msg: "form.save_succes",
              msgPostInner: "",
              delay: 5000
            });
//            modul.AlertInPage.msg = "form.save_succes";
//            modul.AlertInPage.type = "success";
//            setTimeout(function (e) {
//              modul.AlertInPage.msg = "";
//            }, Number(modul.AlertInPage.delay));
            Api.healthCheck({}).then(function (res) {
                HelperRole.healthCheckHandler(modul, res);
              }, function (res) {
                HelperRole.healthCheckHandler(modul, res);
              }
            );
            if (typeof cb === "function") {
              cb();
            }

//            Api.getSettings().then(function (res) {
//              if (res && res.result) {
//                SettingsContainer.setSettings(Array.from(res.data));
//                Helper.updateSettings();
//              }
//            });
          } else {
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "danger",
              msgPreInner: "",
              msg: "form.save_error",
              msgPostInner: "",
              delay: 5000
            });
//            modul.AlertInPage.msg = "form.save_error";
//            modul.AlertInPage.type = "danger";
//            setTimeout(function (e) {
//              modul.AlertInPage.msg = "";
//            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {
          modul.$eventBus.$emit('globalAlert', {
            id_delete: alertId,
            type: "danger",
            msgPreInner: "",
            msg: "form.save_error",
            msgPostInner: "",
            delay: 5000
          });
//          modul.AlertInPage.msg = "form.save_error";
//          modul.AlertInPage.type = "danger";
//          setTimeout(function (e) {
//            modul.AlertInPage.msg = "";
//          }, Number(modul.AlertInPage.delay));
        });
      },

//      getSettings(){
//        const modul = this;
//        Api.getSettings({id_company: modul.state.id_company}).then(function (res) {
//          if (res && res.result && res.data) {
//            modul.data = Array.from(res.data);
//          }
//        });
//      },
      getDocumentSerialNumber(){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getDocumentSerialNumber({id_company: modul.state.id_company}).then(function (res) {
          if (res && res.result && res.data) {
            modul.documentserialnumber = Array.from(res.data);
            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      setMoneys(data){
        const modul = this;
        if (Array.isArray(data)) {

          Array.prototype.forEach.call(data, function (e) {
            if (e.hasOwnProperty('typec') && e.hasOwnProperty('typec_sub') && e.hasOwnProperty('keyc') && e.typec === "money") {
              if (e.typec_sub === "default_type") {
                modul.default_type = e.valuec;
              }
              if (e.typec_sub === "default_presuf") {
                modul.default_presuf = e.valuec;
              }
              if (e.typec_sub === "default_fix") {
                modul.default_fix = e.valuec;
              }
              if (e.typec_sub === "price_number_of_decimals") {
                modul.price_number_of_decimals = e.valuec;
              }
              if (e.typec_sub === "discount_number_of_decimals") {
                modul.discount_number_of_decimals = e.valuec;
              }
              if (e.typec_sub === "sumprice_number_of_decimals") {
                modul.sumprice_number_of_decimals = e.valuec;
              }
              if (e.typec_sub === "defaultdtpaymentdeadline") {
                modul.defaultdtpaymentdeadline = e.valuec;
              }
              if (e.typec_sub === "footertext") {
                modul.footertext = e.valuec;
              }
              if (e.typec_sub === "base_item") {
                modul.base_item = e.valuec;
              }

            }
          });
          Array.prototype.forEach.call(data, function (e) {
            if (e.hasOwnProperty('typec') && e.hasOwnProperty('typec_sub') && e.hasOwnProperty('keyc') && e.typec === "lang") {
              if (e.typec_sub === "default_lang") {
                modul.default_lang = e.valuec;
              }
            }
          });
        }
      },
      setNavs(data){
        const modul = this;
        if (Array.isArray(data)) {

          Array.prototype.forEach.call(data, function (e) {
            if (e.hasOwnProperty('typec') && e.hasOwnProperty('typec_sub') && e.hasOwnProperty('keyc') && e.typec === "nav") {
              if (e.typec_sub === "default_type") {
                modul.default_type = e.valuec;
              }
              if (e.typec_sub === "default_presuf") {
                modul.default_presuf = e.valuec;
              }
              if (e.typec_sub === "default_fix") {
                modul.default_fix = e.valuec;
              }
              if (e.typec_sub === "price_number_of_decimals") {
                modul.price_number_of_decimals = e.valuec;
              }
              if (e.typec_sub === "discount_number_of_decimals") {
                modul.discount_number_of_decimals = e.valuec;
              }
              if (e.typec_sub === "sumprice_number_of_decimals") {
                modul.sumprice_number_of_decimals = e.valuec;
              }
              if (e.typec_sub === "defaultdtpaymentdeadline") {
                modul.defaultdtpaymentdeadline = e.valuec;
              }
              if (e.typec_sub === "footertext") {
                modul.footertext = e.valuec;
              }
              if (e.typec_sub === "base_item") {
                modul.base_item = e.valuec;
              }

            }
          });
          Array.prototype.forEach.call(data, function (e) {
            if (e.hasOwnProperty('typec') && e.hasOwnProperty('typec_sub') && e.hasOwnProperty('keyc') && e.typec === "lang") {
              if (e.typec_sub === "default_lang") {
                modul.default_lang = e.valuec;
              }
            }
          });
        }
      },

      docsernumsave(){
        const modul = this;

        modul.$validator.validateAll().then((result) => {
          if (result) {

            console.log("docsernumsave");
            const arrRow = [];
            const e0 = {};
            e0.type = "offer_cloud";
            e0.idkey = modul.docsernum.offer_key;
            e0.idnextnumber = modul.docsernum.offer_number;
            arrRow.push(e0);
            const e1 = {};
            e1.type = "order_cloud";
            e1.idkey = modul.docsernum.order_key;
            e1.idnextnumber = modul.docsernum.order_number;
            arrRow.push(e1);
            const e2 = {};
            e2.type = "revenue_cloud";
            e2.idkey = modul.docsernum.revenue_key;
            e2.idnextnumber = modul.docsernum.revenue_number;
            arrRow.push(e2);
            const e3 = {};
            e3.type = "buyerorder_cloud";
            e3.idkey = modul.docsernum.buyerorder_key;
            e3.idnextnumber = modul.docsernum.buyerorder_number;
            arrRow.push(e3);
            const e4 = {};
            e4.type = "deliverynote_cloud";
            e4.idkey = modul.docsernum.deliverynote_key;
            e4.idnextnumber = modul.docsernum.deliverynote_number;
            arrRow.push(e4);
            const e5 = {};
            e5.type = "invoice_cloud";
            e5.idkey = modul.docsernum.invoice_key;
            e5.idnextnumber = modul.docsernum.invoice_number;
            arrRow.push(e5);
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.saveDocumentSerialNumber({'data': arrRow}).then(function (res) {
              if (res && res.result) {
                modul.AlertInPage.msg = "form.save_succes";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              } else {
                modul.AlertInPage.msg = "form.save_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              }
            }, function (e) {
              modul.AlertInPage.msg = "form.save_error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });
          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }
        });

      },

      navtest(){
        const modul = this;
        const data = {};
        data.id_company = modul.$store.state.id_company;
        const alertId = Math.random();
        modul.$eventBus.$emit('globalAlert', {
          id: alertId,
          type: "warning",
          msgPreInner: "",
          msg: "form.in_progress",
          msgPostInner: "",
          delay: 50000
        });
//        modul.AlertInPage.msg = "form.in_progress";
//        modul.AlertInPage.type = "warning";
        Api.navTest(data).then(function (res) {
          if (res && res.result) {
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "success",
              msgPreInner: "",
              msg: "setting.succesnavtest",
              msgPostInner: "",
              delay: 5000
            });

//            modul.AlertInPage.msg = "setting.succesnavtest";
//            modul.AlertInPage.type = "success";
//            setTimeout(function (e) {
//              modul.AlertInPage.msg = "";
//            }, Number(modul.AlertInPage.delay));
          } else {
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "danger",
              msgPreInner: "",
              msg: "setting.errornavtest",
              msgPostInner: "",
              delay: 5000
            });

//            modul.AlertInPage.msg = "setting.errornavtest";
//            modul.AlertInPage.type = "danger";
//            setTimeout(function (e) {
//              modul.AlertInPage.msg = "";
//            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {

          modul.$eventBus.$emit('globalAlert', {
            id_delete: alertId,
            type: "danger",
            msgPreInner: "",
            msg: "form.save_error",
            msgPostInner: "",
            delay: 5000
          });
//          modul.AlertInPage.msg = "form.error";
//          modul.AlertInPage.type = "danger";
//          setTimeout(function (e) {
//            modul.AlertInPage.msg = "";
//          }, Number(modul.AlertInPage.delay));
        });
      },

      navsave(){
        const modul = this;
        const data = {};
        data.hasnav = modul.hasnav;
        data.nav_api_version = modul.nav_api_version;
        data.navTechUserName = modul.navTechUserName;
        data.navTechUserPass = modul.navTechUserPass;
        data.navTechXmlSignatureKey = modul.navTechXmlSignatureKey;
        data.navTechXmlChangeKey = modul.navTechXmlChangeKey;
        data.navtaxnumber = modul.navtaxnumber;
//        data.data=Helper.makeFilteredObjectByKeys(modul.data, ["hasnav","nav_api_version","navTechUserName","navTechUserPass","navTechXmlSignatureKey","navTechXmlChangeKey","navtaxnumber"]);
        const postObj = {};
        postObj.id_company = modul.$store.state.id_company;
        postObj.data = data;

//        modul.AlertInPage.msg = "form.in_progress";
//        modul.AlertInPage.type = "warning";
        const alertId = Math.random();
        modul.$eventBus.$emit('globalAlert', {
          id: alertId,
          type: "warning",
          msgPreInner: "",
          msg: "form.in_progress",
          msgPostInner: "",
          delay: 50000
        });


        Api.saveSettingsNav(postObj).then(function (res) {
          if (res && res.result) {
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "success",
              msgPreInner: "",
              msg: "form.save_succes",
              msgPostInner: "",
              delay: 5000
            });

//            modul.AlertInPage.msg = "form.save_succes";
//            modul.AlertInPage.type = "success";
//            setTimeout(function (e) {
//              modul.AlertInPage.msg = "";
//            }, Number(modul.AlertInPage.delay));

//            Api.getSettings().then(function (res) {
//              if (res && res.result) {
//                SettingsContainer.setSettings(Array.from(res.data));
//                Helper.updateSettings();
//              }
//            });
          } else {
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "danger",
              msgPreInner: "",
              msg: "form.save_error",
              msgPostInner: "",
              delay: 5000
            });

//            modul.AlertInPage.msg = "form.save_error";
//            modul.AlertInPage.type = "danger";
//            setTimeout(function (e) {
//              modul.AlertInPage.msg = "";
//            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {
          modul.$eventBus.$emit('globalAlert', {
            id_delete: alertId,
            type: "danger",
            msgPreInner: "",
            msg: "form.save_error",
            msgPostInner: "",
            delay: 5000
          });

//          modul.AlertInPage.msg = "form.save_error";
//          modul.AlertInPage.type = "danger";
//          setTimeout(function (e) {
//            modul.AlertInPage.msg = "";
//          }, Number(modul.AlertInPage.delay));
        });
      },

      getNewContentRow(){
        return {
          default_type: {},
          default_presuf: {},
          default_presuf: "0",
          default_fix: [],

//          default_type: "eur",
//          default_fix: "€",
//          default_presuf: "prefix",
//          cash_settlement: "0",

          default_lang: "",
          data: [],
        };
      },
      /*
       //          row.wsid=null;
       //          row.product_validity=null;
       row.typec=null;
       row.typec_sub=null;
       row.keyc=null;
       row.valuec=null;
       //          row.fieldtype=null;
       //          row.priority=null;
       //          row.deleted=null;
       //          row.create_dt=null;
       */

      moneysave(){
        const modul = this;
        // id 	id_company 	wsid 	product_validity	typec 	typec_sub 	keyc 	valuec 	fieldtype 	priority 	sync_pk 	sync_dt 	sync_mdt 	deleted 	sync_id 	create_dt
        const rows = [];
        const row1 = {};
        row1.typec = "money";
        row1.typec_sub = "default_type";
        row1.keyc = "/";
        row1.valuec = modul.default_type;
        rows.push(row1);
        const row2 = {};
        row2.typec = "money";
        row2.typec_sub = "default_presuf";
        row2.keyc = "/";
        row2.valuec = modul.default_presuf;
        rows.push(row2);
        const row3 = {};
        row3.typec = "money";
        row3.typec_sub = "default_fix";
        row3.keyc = "/";
        row3.valuec = modul.default_fix;
        rows.push(row3);
        const row4 = {};
        row4.typec = "money";
        row4.typec_sub = "price_number_of_decimals";
        row4.keyc = "/";
        row4.valuec = modul.price_number_of_decimals;
        rows.push(row4);
        const row5 = {};
        row5.typec = "money";
        row5.typec_sub = "discount_number_of_decimals";
        row5.keyc = "/";
        row5.valuec = modul.discount_number_of_decimals;
        rows.push(row5);
        const row6 = {};
        row6.typec = "money";
        row6.typec_sub = "sumprice_number_of_decimals";
        row6.keyc = "/";
        row6.valuec = modul.sumprice_number_of_decimals;
        rows.push(row6);
        const row7 = {};
        row7.typec = "money";
        row7.typec_sub = "defaultdtpaymentdeadline";
        row7.keyc = "/";
        row7.valuec = modul.defaultdtpaymentdeadline;
        rows.push(row7);
        const row8 = {};
        row8.typec = "money";
        row8.typec_sub = "footertext";
        row8.keyc = "/";
        row8.valuec = modul.footertext;
        rows.push(row8);
        const row9 = {};
        row9.typec = "money";
        row9.typec_sub = "base_item";
        row9.keyc = "/";
        row9.valuec = modul.base_item;
        rows.push(row9);
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.saveSettingsMoney({"data": rows}).then(function (res) {
          if (res && res.result) {
            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.getSettings().then(function (res) {
              if (res && res.result) {
                SettingsContainer.setSettings(Array.from(res.data));
                Helper.updateSettings();
              }
              modul.AlertInPage.msg = "form.save_succes";
              modul.AlertInPage.type = "success";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });
          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      langsave(){
        const modul = this;
        // id 	id_company 	wsid 	product_validity	typec 	typec_sub 	keyc 	valuec 	fieldtype 	priority 	sync_pk 	sync_dt 	sync_mdt 	deleted 	sync_id 	create_dt
        const rows = [];
        const row1 = {};
        row1.typec = "lang";
        row1.typec_sub = "default_lang";
        row1.keyc = "/";
        row1.valuec = modul.default_lang;
        rows.push(row1);
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.saveSettingsLang({"data": rows}).then(function (res) {
          if (res && res.result) {
            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
    },

    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      AlertInPage,
      InputText,
    },
  };
</script>

<style scoped>
  .inputpositioner {
    flex: 1 1 auto;
    width: 1%;
  }

  .input-group-addon-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .input-group-addon-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
  }

  .contentFieldsContainer tr td {
    padding: 2px 0;
  }
</style>






